module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-operator":"Betreiber","title-bill":"Rechnung","title-owner":"Eigentümer"},"fr":{"title-bill":"Facture","title-operator":"Exploitant","title-owner":"Propriétaire"},"it":{"title-bill":"Fattura","title-operator":"Operatore","title-owner":"Proprietario"}}')
  delete Component.options._Ctor
}
